<div
  class="grid gap-8 h-full relative"
  [ngClass]="(isMobile$ | async) ? 'justify-center text-center' : 'grid-cols-[minmax(auto,250px)_1fr]'">
  <div class="grid gap-6">
    <h3>Template</h3>

    <div class="grid gap-6 overflow-auto overflow-x-hidden max-h-[450px]">
      <sbnb-direct-template-light
        *ngFor="let template of templates"
        [template]="template"
        [isSelected]="directEditService.site.template === template.id"
        (selectTemplate)="updateSiteTemplate(template.id)"></sbnb-direct-template-light>
    </div>

    <h3>General</h3>

    <sbnb-upload-assets
      label="Logo"
      assetType="logo"
      [thumbnails]="[directSiteContentService.logo]"
      [options]="{
        maxFiles: 1,
        fromSources: ['local_file_system', 'url'],
        accept: ['image/jpeg', 'image/png']
      }"
      (uploadSuccess)="directSiteContentService.onLogoUploadSuccess($event)"
      (remove)="directSiteContentService.removeLogo()"></sbnb-upload-assets>

    <h3>Home Page</h3>

    <sbnb-direct-hero-form></sbnb-direct-hero-form>

    <sbnb-upload-assets
      label="Hero background images"
      assetType="image"
      [thumbnails]="directSiteContentService.images"
      [options]="{
        maxFiles: 30,
        fromSources: ['local_file_system', 'url'],
        accept: ['image/jpeg', 'image/png']
      }"
      (uploadSuccess)="directSiteContentService.onGalleryUploadSuccess($event)"
      (remove)="directSiteContentService.removeImage($event)"></sbnb-upload-assets>

    <sbnb-upload-assets
      label="Hero background video"
      assetType="video"
      [thumbnails]="[directSiteContentService.video ? 'https://placehold.co/300x300' : undefined]"
      [options]="{
        maxFiles: 1,
        maxSize: 30 * 1024 * 1024,
        fromSources: ['local_file_system', 'url'],
        accept: ['video/*']
      }"
      (uploadSuccess)="directSiteContentService.onVideoSuccess($event)"
      (remove)="directSiteContentService.removeVideo()"></sbnb-upload-assets>

    <h3>Social</h3>

    <sbnb-direct-social-form></sbnb-direct-social-form>

    <h3>Footer</h3>

    <sbnb-direct-footer-form></sbnb-direct-footer-form>
  </div>

  <div class="grid gap-6 grid-rows-[auto_1fr] sticky top-8 self-start" *ngIf="!(isMobile$ | async)">
    <h3>Preview</h3>

    <mat-progress-bar
      *ngIf="directSiteContentService.loading"
      mode="indeterminate"
      class="z-10 h-[6px]"
      [style.grid-area]="'2 / 1 / 2 / 1'"></mat-progress-bar>
    <iframe
      *ngIf="iframeSrc"
      [src]="iframeSrc"
      frameborder="0"
      class="border border-smoke aspect-video w-full rounded-md"
      [ngClass]="{ 'blur-[1.5px]': directSiteContentService.loading }"
      style="zoom: 0.7; grid-area: 2 / 1 / 2 / 1"></iframe>
  </div>
</div>
